<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="12">
        <div class="mb6 selectRegion">
          <div class="title">select one or more</div>
          <div>
            <div class="searchInput">
              <el-input v-model="searchContent" size="mini" clearable placeholder="Search items…"></el-input>
            </div>
            <div class="hg124 itemWrap">
              <el-checkbox-group v-model="checkedBankIds" v-if="filteredBankList.length > 0">
                <div class="checkboxWrap" v-for="item in filteredBankList" :key="`checkbox-${item.id}`">
                  <el-checkbox :label="item.id">
                    <div class="enbr feed">
                      <span class="fwb">{{ item.tag }}</span>
                      <span class="ml4 mr4">—</span>
                      <span>{{ item.bankName }}</span>
                      <span class="ml4 mr4">|</span>
                      <span>{{ item.accountNumber }}</span>
                      <span class="ml4 mr4">|</span>
                      <span>{{ item.accountName }}</span>
                      <span class="ml4 mr4">|</span>
                      <el-tag type="success" size="mini" class="fs10">{{ item.billingCurrency }}</el-tag>
                    </div>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
              <div class="emptyHint" v-else>No matching accounts</div>
            </div>
          </div>
        </div>
        <el-button type="primary" size="mini" plain @click="selectedHandle">Add Selected</el-button>
      </el-col>
      <el-col :span="12">
        <div class="mb6 selectRegion">
          <div class="title">selected bank account</div>
          <div class="hg160 itemWrap">
            <div class="wdb100 el-checkbox-group" v-if="selectedBankAccountList.length > 0">
              <div class="checkboxWrap" v-for="(item, index) in selectedBankAccountList" :key="`selected-${item.id}`">
                <div class="enbr feed justify-between el-checkbox">
                  <div class="pl0 el-checkbox__label">
                    <span class="fwb">{{ item.tag }}</span>
                    <span class="ml4 mr4">—</span>
                    <span>{{ item.bankName }}</span>
                    <span class="ml4 mr4">|</span>
                    <span>{{ item.accountNumber }}</span>
                    <span class="ml4 mr4">|</span>
                    <span>{{ item.accountName }}</span>
                    <span class="ml4 mr4">|</span>
                    <el-tag type="success" size="mini" class="fs10">{{ item.billingCurrency }}</el-tag>
                  </div>
                  <div class="pl10 el-checkbox__input">
                    <el-button type="text" size="mini" class="pd0 fwb red el-icon-close" @click="deleteItem(index)"></el-button>
                    <el-button type="text" size="mini" class="pd0 fwb el-icon-top" :disabled="index == 0" @click="moveItem(index, -1)"></el-button>
                    <el-button
                      type="text"
                      size="mini"
                      class="pd0 fwb el-icon-bottom"
                      :disabled="index == selectedBankAccountList.length - 1"
                      @click="moveItem(index, 1)"
                    ></el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="emptyHint" v-else>No bank account added</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    // v-model 绑定的 bankAccountIds 数组
    value: {
      type: Array,
      default: () => [],
    },
    // 供选择的源数据列表
    supplierBankAccountList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchContent: "", // 检索关键词
      checkedBankIds: [], // 左侧多选框当前勾选的 ID 数组
      selectedBankAccountList: [], // 右侧已确认添加的 完整对象 数组
    };
  },
  computed: {
    filteredBankList() {
      const search = this.searchContent.trim().toLowerCase();
      if (!search) return this.supplierBankAccountList;

      return this.supplierBankAccountList.filter(item => {
        // 在 tag、银行名称、账号中进行匹配
        return (
          (item.tag && item.tag.toLowerCase().includes(search)) ||
          (item.bankName && item.bankName.toLowerCase().includes(search)) ||
          (item.accountNumber && item.accountNumber.toLowerCase().includes(search)) ||
          (item.accountName && item.accountName.toLowerCase().includes(search)) ||
          (item.billingCurrency && item.billingCurrency.toLowerCase().includes(search))
        );
      });
    },
  },
  watch: {
    // 监听 value 实现初始化和外部赋值回显
    value: {
      handler(newIds) {
        // 如果长度一致且 ID 顺序相同，则不处理，避免内部 emit 导致的循环
        const currentIds = this.selectedBankAccountList.map(item => item.id);
        if (JSON.stringify(newIds) === JSON.stringify(currentIds)) return;

        // 根据传入的 ID 数组，从源数据中匹配完整的对象
        // 这样可以保证 selectedBankAccountList 的顺序与 value 的 ID 顺序一致
        const matchedList = [];
        (newIds || []).forEach(id => {
          const found = this.supplierBankAccountList.find(item => item.id === id);
          if (found) matchedList.push(found);
        });
        this.selectedBankAccountList = matchedList;
      },
      immediate: true, // 关键：组件创建时立即执行一次以回显
    },
  },
  methods: {
    // 将选中的银行账户添加到右侧
    selectedHandle() {
      if (this.checkedBankIds.length === 0) return;

      const currentSelectedIds = this.selectedBankAccountList.map(item => item.id);

      this.checkedBankIds.forEach(id => {
        if (!currentSelectedIds.includes(id)) {
          const item = this.supplierBankAccountList.find(bank => bank.id === id);
          if (item) this.selectedBankAccountList.push(item);
        }
      });

      this.checkedBankIds = []; // 清空勾选
      this.emitInput();
    },
    // 删除操作
    deleteItem(index) {
      this.selectedBankAccountList.splice(index, 1);
      this.emitInput();
    },
    // 排序操作
    moveItem(index, direction) {
      const nextIndex = index + direction;
      if (nextIndex < 0 || nextIndex >= this.selectedBankAccountList.length) return;
      const targetItem = this.selectedBankAccountList.splice(index, 1)[0];
      this.selectedBankAccountList.splice(nextIndex, 0, targetItem);
      this.emitInput();
    },
    // 统一发送 input 事件更新父组件 v-model
    emitInput() {
      const bankAccountIds = this.selectedBankAccountList.map(item => item.id);
      this.$emit("input", bankAccountIds);
    },
  },
};
</script>

<style lang="scss" scoped>
.searchInput {
  padding: 0px 8px;
}

::v-deep {
  .el-input__inner {
    border-color: #dcdfe6 !important;
  }
}

.itemWrap {
  overflow-y: auto;

  .emptyHint {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 14px;
    color: #909399;
  }
}
</style>
